import React, { useState } from 'react'
import {
  Button,
  GridItem,
  GridWrapper,
  ItemsGrid,
  PageWrapper,
  Flex,
  MainHeadline,
  PageFooter,
} from '../../styling/GlobalStyles'
import { Pagination } from '../../components/Pagination/Pagination'
import { useNavigate } from 'react-router-dom'
import {
  clearOperationGroupsList,
  deleteOperationGroup,
  getOperationGroups,
} from '../../features/operationGroups/operationGroupsSlice'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../components/NavBar/NavBar'
import RemoveCircle from 'assets/icons/RemoveCircle'
import { setConfirmModal } from 'features/global/globalSlice'
import { AppDispatch, RootState } from 'store'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { getParams, handlePagination } from 'utils/helpers'
import { ModalTypes } from 'types/global.interface'
import useQueryPagination from 'hooks/useQueryPagination'
import { INameId } from 'constants/globalTypes'

export const OperationGroups = () => {
  const { operationGroups, totalPages } = useSelector(
    (store: RootState) => store.operationGroups,
  )
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const [params, setParams] = useState<any>(getParams({ location, ap: { sd: 'a', s: 'name' } }))

  useQueryPagination({ fetchFunctions: [getOperationGroups], cleanUpFunctions: [clearOperationGroupsList], params })


  const handleRemove = (id: number | string) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteOperationGroup(id))
        },
        setParams: {
          type: ModalTypes.Delete,
          f: setParams,
          noItems: operationGroups.length < 2,
        },
        word: 'delete operation group',
      }),
    )
  }

  return (
    <>
      <NavBar
        input
        defaultValue={params.q}
        placeholder='Search Operation Groups...'
        setParams={setParams}
        searchFields={['name']}
      />
      <PageWrapper>
        <Flex between center mb='16' >
          <MainHeadline>Operation Groups</MainHeadline>
          <Button orange onClick={() => navigate('/operation-groups/add')}>
            Add Group
          </Button>
        </Flex>
        <GridWrapper>
          <ItemsGrid columns={3}>
            {operationGroups?.length ? (
              operationGroups?.map((item: INameId, key: number) => {
                return (
                  <GridItem key={key}>
                    <p onClick={() => navigate('/operation-groups/view/' + item.id)}>{item.name}</p>
                    <Flex center justcenter onClick={() => handleRemove(item.id)}>
                      <RemoveCircle />
                    </Flex>
                  </GridItem>
                )
              })
            ) : (
              <NoItems title='Operation Groups' />
            )}
          </ItemsGrid>
        </GridWrapper>
      </PageWrapper>
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
    </>
  )
}
